import { combineReducers } from 'redux';

import type { EntitySlice } from 'utils/ReduxUtils';

import byAuditId from './byAuditId';
import type { AuditEventIdsByAuditId } from './byAuditId';
import data from './data';
import type { PaginatedAuditEvent } from '../../types/projections/paginated-audit-event';

export type AuditEventsReducer = {
  data: EntitySlice<PaginatedAuditEvent>;
  byAuditId: AuditEventIdsByAuditId;
};

export default combineReducers({
  data,
  byAuditId,
});
